const baseApiUrl: string | undefined = import.meta.env.VITE_GLOB_API_URL;
const modulesFiles: any = import.meta.glob('./*.ts', { eager: true });
const modules = Object.values(modulesFiles).map((module: any) => module.default);

const mockInterceptors = (mock: any) => {
  modules.forEach((module) => {
    Object.keys(module).forEach((url: string) => {
      const item: any = module[url];

      let mockUrl: any = (baseApiUrl + url).replace(/(?<!:)\/{2,}/g, '/');
      mockUrl = mockUrl.indexOf('*') > -1 ? new RegExp(mockUrl) : mockUrl;

      // console.log(mockUrl);

      if (item?.method?.toLowerCase() === 'get') {
        if (item.data instanceof Function) {
          mock.onGet(mockUrl).reply(item.data);
        } else {
          mock.onGet(mockUrl).reply(200, item.data);
        }
      } else {
        if (item.data instanceof Function) {
          mock.onPost(mockUrl).reply(item.data);
        } else {
          mock.onPost(mockUrl).reply(200, item.data);
        }
      }
    });
  });
};

export default mockInterceptors;
